<!--
    使用例子
    <context-menu id="context-menu" ref="allMenu">
          <li class="ctx-item" @click="addIndex(currentNode)">新建目录</li>
          <li class="ctx-item"  @click="editIndex(currentNode)">编辑目录</li>
          <li class="ctx-item"  @click="deleteIndex(currentNode)">删除目录</li>
    </context-menu>
-->
<template>
  <div class="context-menu">
    <!--
      @mouseleave.native="leave"
     -->
    <VueContextMenu ref="menu" @ctx-cancel="ctxCancel">
      <slot></slot>
    </VueContextMenu>
  </div>
</template>


<script>
import VueContextMenu from 'vue-context-menu'
export default {
  name: 'context-menu',
  data() {
    return {}
  },
  components: {
    VueContextMenu
  },
  methods: {
    // 打开menu
    open(event) {
      this.$refs.menu.open(event)
    },
    // 关闭menu
    close() {
      this.$refs.menu.ctxVisible = false
    },
    leave() {
      // this.$refs.menu.ctxVisible = false
    },

    ctxCancel() {
      this.$emit('ctxCancel')
    },
  }
}
</script>

<style>
.context-menu .ctx-menu-container{
  border: none;
}

.context-menu ul.ctx-menu{
    text-align: center;
    min-width: 100px;
    padding: 0;
}

.context-menu ul.ctx-menu .ctx-item{
    padding: 0;
}

/* .context-menu ul.ctx-menu li:hover{
  background-color: red;
} */

</style>
